@if(entity)
{
  <h2> {{entity.title}}</h2>
  <h3> ({{entity.inventoryCount}}) - {{draftOrActive}} </h3>
  <h3> {{entity.country_Name}} </h3>
}

<div class="box content">
  <app-detail-layout [name]="name"
                     [id]="id"
                     [apiController]="apiController"
                     [views]="views"
                     viewType="tab"
                     [toolbarItems]="toolbarItems"
                     [showSaveButton]="updateItemPermission"
                     [showRemoveButton]="false"
                     [keyFieldName]="keyFieldName"
                     (entityLoaded)="entityLoaded()"
                     [(entity)]="entity"
                     [preSave]="true"
                     (save)="preSave($event)"
                     [breadCrumbPropertyNames]="breadCrumbPropertyNames">
  </app-detail-layout>
</div>

<kendo-stacklayout orientation="vertical" style="width:100%">
  <div class="gridsContainer">

    <div #orderSection>
      <form novalidate #orderForm="ngForm">
        @if(entity && isAdmin) {
        <kendo-grid #grid
                    id="ItemUniqueSearch_Grid"
                    [kendoGridBinding]="itemUniqnumList"
                    [data]="itemUniqnumList"
                    [sortable]="true"
                    [filterable]="false"
                    [resizable]="true"
                    [reorderable]="true"
                    [groupable]="false"
                    [pageSize]="100"
                    [selectable]="selectableSettings"
                    (cellClick)="onCellClicked($event)"
                    [pageable]="pagerSettings"
                    [skip]="state.skip || 0"
                    [sort]="state.sort || []"
                    style="height:100%; width: 100%">

          <kendo-grid-column field="uniqnum" title="Uniqnum" filter="text" [width]="70" [editable]="false"></kendo-grid-column>
          <kendo-grid-column field="status" title="Status" filter="text" [width]="70" [editable]="false"></kendo-grid-column>
          <kendo-grid-column field="serial" title="Serial" filter="text" [width]="70" [editable]="false"></kendo-grid-column>
          <div>
          </div>
        </kendo-grid>
        <kendo-contextmenu #gridMenu
                           [kendoMenuHierarchyBinding]="contextMenuItems"
                           [textField]="'title'"
                           childrenField="items"
                           svgIconField="iconClass"
                           separatorField="separator"
                           (select)="onContextMenuSelect($event)">
        </kendo-contextmenu>
        }
      </form>
    </div>
  </div>

</kendo-stacklayout>
